import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import styled from 'styled-components';
const getCheckboxSize = size => size === 'medium' ? 24 : 20;
const backgroundColor = (checked, hasError, hover) => {
  if (hasError) return 'var(--checkbox-background-color-error)';
  if (checked && hover) return 'var(--checkbox-background-color-checked-hover)';
  if (checked) return 'var(--checkbox-background-color-checked)';
  if (hover) return 'var(--checkbox-background-color-hover)';
  return 'var(--checkbox-background-color-base)';
};
const borderColor = (checked, hasError, hover) => {
  if (hasError) return 'var(--checkbox-border-color-error)';
  if (checked && hover) return 'var(--checkbox-background-color-checked-hover)';
  if (checked) return 'var(--checkbox-background-color-checked)';
  if (hover) return 'var(--checkbox-border-color-hover)';
  return 'var(--checkbox-border-color-base)';
};
export const ContainerLabel = styled.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: fit-content;\n  display: inline-flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  outline: none;\n  border-radius: var(--border-radius-xxs);\n\n  ", ";\n"])), _ref => {
  let {
    disabled
  } = _ref;
  return disabled && "\n      opacity: var(--opacity-intense);\n      cursor: not-allowed;\n    ";
});
export const NativeInput = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  width: 1px;\n  height: 1px;\n"])));
export const SpanInput = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-self: flex-start;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: ", "px;\n  width: ", "px;\n  max-width: ", "px;\n  min-height: ", "px;\n  height: ", "px;\n  max-height: ", "px;\n  padding: var(--spacing-0-25);\n  border-radius: var(--border-radius-xs);\n  :focus-within {\n    outline: var(--color-neutral-130) solid var(--border-width-thin);\n    /* outline-offset: var(--border-width-thin); */\n  }\n"])), _ref2 => {
  let {
    size
  } = _ref2;
  return getCheckboxSize(size);
}, _ref3 => {
  let {
    size
  } = _ref3;
  return getCheckboxSize(size);
}, _ref4 => {
  let {
    size
  } = _ref4;
  return getCheckboxSize(size);
}, _ref5 => {
  let {
    size
  } = _ref5;
  return getCheckboxSize(size);
}, _ref6 => {
  let {
    size
  } = _ref6;
  return getCheckboxSize(size);
}, _ref7 => {
  let {
    size
  } = _ref7;
  return getCheckboxSize(size);
});
export const LabelWrapper = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), _ref8 => {
  let {
    size
  } = _ref8;
  return size === 'medium' ? 'var(--spacing-1)' : 'var(--spacing-0-5)';
});
export const CheckboxInputStylized = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  border-color: ", ";\n  border-width: var(--border-width-hairline);\n  border-radius: var(--border-radius-xxs);\n  border-style: solid;\n\n  ", ":hover:not([disabled]) & {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  ", ":active:not([disabled]) & {\n    transform: scale(0.92);\n  }\n\n  svg {\n    fill: var(--checkbox-color-icon);\n  }\n"])), _ref9 => {
  let {
    size
  } = _ref9;
  return size === 'small' ? '12px' : '100%';
}, _ref10 => {
  let {
    size
  } = _ref10;
  return size === 'small' ? '12px' : '100%';
}, _ref11 => {
  let {
    checked,
    hasError
  } = _ref11;
  return backgroundColor(checked, hasError, false);
}, _ref12 => {
  let {
    checked,
    hasError
  } = _ref12;
  return borderColor(checked, hasError, false);
}, ContainerLabel, _ref13 => {
  let {
    checked,
    hasError
  } = _ref13;
  return backgroundColor(checked, hasError, true);
}, _ref14 => {
  let {
    checked,
    hasError
  } = _ref14;
  return borderColor(checked, hasError, true);
}, ContainerLabel);
export const ErrorMessageWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 16px auto;\n  column-gap: 4px;\n  margin-top: var(--spacing-0-5);\n\n  * {\n    color: var(--color-feedback-error-100);\n  }\n"])));